import clsx from 'clsx';
import React from 'react';

const ProductCardPlaceholder = ({ className }: { className?: string }) => {
  return (
    <div
      className={clsx(
        'm-w-0 skeleton group flex h-full max-w-full flex-col rounded bg-white',
        className
      )}
    >
      <div className="image-wrapper relative">
        <div className="flex overflow-hidden rounded bg-gray-200 aspect-[3/4]"></div>
      </div>
      <div className="flex flex-1 flex-col rounded pt-4 lg:pt-3">
        <div className="h4 mb-0.5 block overflow-hidden text-ellipsis whitespace-nowrap rounded bg-gray-200 font-normal">
          &nbsp;
        </div>
        <div className="rounded bg-gray-200">&nbsp;</div>
      </div>
    </div>
  );
};

export default ProductCardPlaceholder;
